import Spinner from './Spinner';

export { SpinnerWithTitle } from './SpinnerWithTitle';

export default Spinner;
